// extracted by mini-css-extract-plugin
module.exports = {"text-text":"Text_text-text__dIIQz"};